export default {
    account: 'Λογαριασμός',
    activationFailed: 'Κάτι πήγε λάθος με την ενεργοποίηση του e-mail!',
    sidebar: {
        dashboard: 'Προφιλ χρήστη',
        company: 'Στοιχεία εταιρείας',
        password: 'Κωδικός πρόσβασης',
        todo: 'Λίστα to-do',
        tags: 'Ετικέτες',
        subscription: 'Πληροφορίες συνδρομής & ανανέωση',
        printTemplates: 'Πρότυπα εκτύπωσης',
        noteTemplates: 'Πρότυπα σημειώσεων',
        questionnaires: 'Ερωτηματολόγια',
        serial: 'Σειριακός αρ.',
        sms: 'Ρυθμίσεις SMS'
    },
    profile: {
        nonActivatedEmail: 'Δεν έχετε επιβεβαιώσει το e-mail σας.',
        missingPhone: 'Παρακαλώ συμπληρώστε το τηλέφωνό σας για ευκολότερη υποστήριξη και ενημέρωση!',
        edit: 'Επεξεργασία προφίλ',
        resendActivation: 'Επαναποστολή συνδέσμου επιβεβαίωσης',
        emailActivationError: 'Κάτι πήγε λάθος με την ενεργοποίηση του e-mail!',
        uploadLogo: {
            title: 'Λογότυπο',
            subtitle: 'Ανεβάστε το λογότυπό σας (για εκτυπώσεις κ.λπ.)'
        },
        addRemoveImage: 'Προσθήκη / αλλαγή εικόνας',
        user: {
            title: 'Πληροφορίες Χρήστη',
            subtitle: 'Επεξεργαστείτε τις βασικές σας πληροφορίες & τα κοινωνικά σας δίκτυα',
            insertYour: 'Εισάγετε το {field} σας',
            insertYourShe: 'Εισάγετε τη {field} σας',
            insertYourSheN: 'Εισάγετε την {field} σας',
            bio: 'Βιογραφικό',
            social: {
                title: 'Κοινωνικά δίκτυα',
                website: 'Ιστοσελίδα',
                facebook: 'Facebook',
                instagram: 'Instagram',
                twitter: 'Twitter',
                linkedin: 'LinkedIn'
            }
        }
    },
    imageUpload: {
        profileImage: 'Εικόνα προφίλ',
        hint: 'Πατήστε εδώ ή σύρετε μία εικόνα',
        onlyImg: 'Παρακαλώ εισάγετε εικόνα',
        outOfSize: 'Η εικόνα ξεπερνάει το όριο: ',
        lowestPx: 'Το μέγεθος της εικόνας παραείναι μικρό. Αναμενόμενο ελάχιστο μέγεθος: '
    },
    company: {
        title: 'Στοιχεία Εταιρείας',
        subtitle: 'Εισάγετε τα στοιχεία της τιμολόγησής σας',
        company: 'Επωνυμία εταιρείας',
        companyPlaceholder: 'Εισάγετε την επωνυμία της εταιρείας σας',
        occupation: 'Επάγγελμα',
        vat: 'Α.Φ.Μ',
        doy: 'Δ.Ο.Υ.'
    },
    changePassword: {
        title: 'Αλλαγή Κωδικού Πρόσβασης',
        subtitle: 'Αλλάξτε τον κωδικό σύνδεσής σας στην εφαρμογή',
        password: 'Τωρινός κωδικός πρόσβασης',
        newPassword: 'Νέος κωδικός πρόσβασης',
        placeholders: {
            password: 'Εισάγετε τον τωρινό κωδικό πρόσβασής σας',
            repeatPassword: 'Επαναλάβετε τον νέο κωδικό πρόσβασής σας.',
            newPassword: 'Εισάγετε τον νέο κωδικό πρόσβασής σας.',
        },
        passwordsNoMatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν.',
        minLength: 'Τουλάχιστον {min} χαρακτήρες.',
        save: 'Αλλαγή κωδικού πρόσβασης'
    },
    tags: {
        title: 'Ετικέτες',
        subtitle: 'Διαχειριστείτε όλες τις ετικέτες σας',
        athlete: 'Ετικέτες αθλητών',
        dietPlans: 'Ετικέτες διατροφικών πλάνων',
        templates: 'Ετικέτες πρότυπων γευμάτων',
        recipes: 'Ετικέτες συνταγών',
        edit: 'Επεξεργασία ετικέτας',
        name: 'Όνομα ετικέτας',
        empty: 'Δεν υπάρχουν ετικέτες σε αυτή την κατηγορία'
    },
    subscriptions: {
        title: 'Πληροφορίες συνδρομής',
        subtitle: 'Μάθετε πότε λήγει η συνδρομή σας & τις χρεώσεις σας',
        instalmentExpiry: 'Έχετε {days} ημέρες για να εξοφλήσετε την επόμενη δόση σας!',
        instalmentOverdue: 'Το περιθώριο για την εξόφληση της δόσης έχει λήξει.',
        cost: 'Κόστος ετήσιας συνδρομής: 149,90€ + Φ.Π.Α.',
        daysUntil: 'Ημέρες μέχρι την επόμενη ανανέωση:',
        remaining: 'Απομένουν {days} μέρες',
        pay: 'Εξόφληση',
        renew: 'Ανανέωση ετήσιας συνδρομής',
        statuses: {
            COMPLETED: 'Ολοκληρωμένη',
            PENDING: 'Αναμένεται πληρωμή'
        },
        remainingLong: '<p>Απομένουν <strong>{days} ημέρες</strong> μέχρι την επόμενη ανανέωση</p>',
        expired: '<p>Η συνδρομή σου έληξε στις <strong>{date}</strong></p>'
    },
    history: {
        title: 'Ιστορικό συναλλαγών',
        subtitle: 'Όλες οι συναλλαγές σου',
        amount: 'Ποσό',
        doses: 'Δόσεις',
        due: 'Εξόφληση έως',
        pay: 'Πληρωμή',
        payNow: 'Πληρωμή τώρα',
        status: 'Κατάσταση',
        pending: 'Μελλοντική πληρωμή',
        completed: 'Ολοκληρωμένες',
        payNextRenewal: 'Εξόφληση επόμενης ανανέωσης',
        payUntil: 'Πληρωμή έως {date}',
        type: {
            title: 'Είδος συναλλαγής',
            PURCHASE: 'Αγορά λογισμικού',
            RENEW: 'Ετήσια ανανέωση',
            PURCHASE_INSTALMENT: 'Δόση αγοράς'
        },
        empty: {
            title: 'Χωρίς συναλλαγές',
            subtitle: 'Οι πληρωμές σου θα εμφανίζονται εδώ.'
        }
    },
    sms: {
        title: 'Ρυθμίσεις SMS',
        subtitle: 'Διαχείριση συνδρομής SMS και ιστορικό χρήσης',
        comingSoon: {
            title: 'Σύντομα κοντά σας',
            subtitle: 'Η λειτουργία SMS θα είναι διαθέσιμη σύντομα. Μείνετε συντονισμένοι!'
        },
        subscription: {
            title: 'Συνδρομή SMS',
            subtitle: 'Διαχείριση συνδρομής SMS και χρήσης',
            status: 'Κατάσταση',
            statusActive: 'Ενεργή',
            period: 'Περίοδος',
            startDate: 'Ημερομηνία έναρξης',
            endDate: 'Ημερομηνία λήξης',
            manageSubscription: 'Διαχείριση συνδρομής',
            createSubscription: 'Δημιουργία συνδρομής',
            tabs: {
                details: 'Λεπτομέρειες'
            },
            empty: {
                title: 'Δεν υπάρχει ενεργή συνδρομή',
                subtitle: 'Ενεργοποιήστε μια συνδρομή για να ξεκινήσετε!'
            },
            marketing: {
                title: 'SMS Υπενθυμίσεις Ραντεβού',
                subtitle: 'Στείλτε αυτόματα υπενθυμίσεις στους πελάτες σας πριν από το επόμενο ραντεβού τους',
                cta: 'Ενεργοποιήστε SMS Υπενθυμίσεις',
                previewTitle: 'Προεπισκόπηση μηνύματος',
                previewRecipient: 'Πελάτης',
                sampleMessage: 'Γεια σας! Αυτό είναι ένα δείγμα SMS υπενθύμισης για το ραντεβού σας.'
            }
        },
        faq: {
            title: 'Συχνές Ερωτήσεις',
            0: {
                question: 'Πότε αποστέλλεται το SMS;',
                answer: 'Το SMS αποστέλλεται αυτόματα 24 ή 48 ώρες πριν το ραντεβού, ανάλογα με την επιλογή σου στις ρυθμίσεις της υπηρεσίας.'
            },
            1: {
                question: 'Μπορώ να αλλάξω το χρονικό διάστημα (24/48 ώρες);',
                answer: 'Ναι. Από τις ρυθμίσεις της υπηρεσίας μπορείς να επιλέξεις αν θέλεις το SMS να αποσταλεί 24 ώρες πριν ή 48 ώρες πριν το ραντεβού. Επίσης αυτό ρυθμίζεται και ανά ραντεβού. Δεν υπάρχει δυνατότητα για άλλες ώρες προς το παρόν, ώστε η αποστολή να γίνεται αποκλειστικά εντός εργάσιμων ωρών και να αποφεύγονται ενοχλητικά μηνύματα νωρίς το πρωί ή αργά το βράδυ.' 
            },
            2: {
                question: 'Θα μπορώ να βλέπω αν παραδόθηκε το SMS;',
                answer: 'Ναι. Στην καρτέλα του προφιλ --> Ρυθμίσεις SMS εμφανίζονται οι καταστάσεις αποστολής (στάλθηκαν / προγραμματισμένα / αποτυχία αποστολής).'
            },
            3: {
                question: 'Τι γίνεται αν αλλάξω την ώρα ή την ημέρα του ραντεβού;',
                answer: 'Η πλατφόρμα ενημερώνει αυτόματα το σύστημα SMS. Το μήνυμα θα σταλεί με βάση τη νέα ώρα του ραντεβού χωρίς να χρειάζεται να κάνεις τίποτα. '
            },
            4: {
                question: 'Τι γίνεται αν ακυρώσω το ραντεβού;',
                answer: 'Αν διαγράψεις το ραντεβού πριν την προγραμματισμένη ώρα αποστολής, το SMS δεν θα σταλεί. Για παράδειγμα αν ακυρώσεις η διαγράψεις το ραντεβού με ρύθμιση αποστολής 24 ώρες πριν τότε δεν θα έχει φύγει το μήνυμα και δεν το χρεώνεσαι. Αν το ακυρώσεις για παράδειγμα στις 23 ώρες θα έχει ήδη φύγει.',
            },
            5: {
                question: 'Η υπηρεσία SMS χρεώνεται;',
                answer: 'Ναι, η υπηρεσία SMS σε αντίθεση με τις άλλες λειτουργίες έχει μια μικρή χρέωση ανά πακέτο μηνυμάτων και η κατανάλωση εμφανίζεται αναλυτικά στον λογαριασμό σου στο Athlisis. Η φιλοσοφία μας είναι να προσθέτουμε συνεχώς νέες λειτουργίες χωρίς επιπλέον κόστος για τον διαιτολόγο. Η συγκεκριμένη υπηρεσία είναι η πρώτη που έχει χρέωση, καθώς εξαρτόμαστε σε εξωτερικό πάροχο για την αποστολή των SMS.',
            },
            6: {
                question: 'Ο πελάτης μπορεί να απαντήσει στο SMS;',
                answer: 'Όχι. Τα μηνύματα είναι μονόδρομα. Αν θέλεις να επικοινωνήσουν μαζί σου μπορούν να σε καλέσουν ή να σου στείλουν μήνυμα στα στοιχεία που έχουν από εσένα ή μέσω της mobile εφαρμογής που έχετε κάνει διασύνδεση.',
            },
            7: {
                question: 'Μπορώ να αλλάξω το κείμενο του SMS;',
                answer: 'Ναι, από τις ρυθμίσεις SMS. Ένα SMS χωράει έως 70 χαρακτήρες· αν το κείμενο είναι μεγαλύτερο, στέλνεται σε κομμάτια των 67 χαρακτήρων και κάθε κομμάτι χρεώνεται ως ένα SMS από το πακέτο σου (έως 3 ανά υπενθύμιση). Ο μετρητής κάτω από το κείμενο δείχνει πόσα SMS θα κοστίζει κάθε υπενθύμιση. Το κείμενο πρέπει να περιέχει την ημερομηνία και την ώρα του ραντεβού και δεν επιτρέπονται σύνδεσμοι.',
            },
            8: {
                question: 'Τι γίνεται αν ο πελάτης έχει δώσει λάθος αριθμό κινητού;',
                answer: 'Το Athlisis εφαρμόζει έναν πρώτο έλεγχο στον αριθμό που καταχωρείς (αριθμός ψηφίων και σωστή αρχική μορφή), ώστε να αποφεύγονται άμεσα τα πιο συνηθισμένα λάθη. Αν ο αριθμός δεν πληροί αυτά τα βασικά κριτήρια, το SMS δεν αποστέλλεται, και εμφανίζεται μήνυμα σφάλματος χωρίς καμία χρέωση. Μπορείς ανά πάσα στιγμή να διορθώσεις τον αριθμό από την καρτέλα του πελάτη. Όμως για να ενημερωθεί θα πρέπει να ανανεώσεις το ραντεβού στο ημερολόγιο.',
            },
            9: {
                question: 'Στέλνονται SMS και για διαδικτυακά ραντεβού;',
                answer: 'Βεβαίως. Η υπενθύμιση αφορά κάθε τύπο ραντεβού που καταχωρείς στο Calendar.',
            },

            10: {
                question: 'Αν το ραντεβού δημιουργηθεί τελευταία στιγμή (π.χ. σε 8 ώρες), τι γίνεται;',
                answer: 'Αν δεν υπάρχει διαθέσιμο παράθυρο 24 ή 48 ωρών με βάση το τι έχει οριστεί, το SMS δεν στέλνεται για να αποφεύγονται άσκοπα μηνύματα.',
            },
            11: {
                question: 'Μπορώ να επιλέξω ποιοι πελάτες θα λαμβάνουν SMS;',
                answer: 'Ναι. Στο ημερολόγιο κατα την εισαγωγή του ραντεβού υπάρχει επιλογή ενεργοποίησης/απενεργοποίησης υπενθύμισης SMS.',
            },
            12: {
                question: 'Έχω πολλαπλά ραντεβού την ίδια ημέρα. Στέλνονται πολλά SMS;',
                answer: 'Ναι, κάθε ραντεβού λειτουργεί ανεξάρτητα και λαμβάνει το δικό του SMS υπενθύμισης.',
            },
            13: {
                question: 'Αν το SMS αποτύχει, ενημερώνομαι κάπως ή χρεώνομαι;',
                answer: 'Στην καρτέλα του προφιλ --> SMS αν έχει αποτύχει θα εμφανιστεί στα “Μη Απεσταλμένα Μηνύματα”. Σε αυτή την περίπτωση δεν χρεώνεσαι για το μήνυμα.',
            },

            items: {
                howItWorks: {
                    question: 'Πώς λειτουργεί η υπηρεσία SMS;',
                    answer: 'Η υπηρεσία SMS στέλνει αυτόματα υπενθυμίσεις στους πελάτες σας 24 ώρες πριν από το επόμενο ραντεβού τους. Μπορείτε να προσαρμόσετε το χρονικό διάστημα (προεπιλογή: 24 ώρες).'
                },
                pricing: {
                    question: 'Ποια είναι η τιμή της συνδρομής;',
                    answer: 'Η συνδρομή SMS προσφέρει ένα συγκεκριμένο αριθμό SMS ανά περίοδο. Για περισσότερες πληροφορίες σχετικά με τις τιμές, επισκεφτείτε την πύλη Stripe.'
                },
                cancel: {
                    question: 'Πώς μπορώ να ακυρώσω τη συνδρομή μου;',
                    answer: 'Μπορείτε να διαχειριστείτε ή να ακυρώσετε τη συνδρομή σας μέσω της πύλης Stripe πατώντας το κουμπί "Άνοιγμα πύλης Stripe".'
                },
                usage: {
                    question: 'Τι συμβαίνει αν ξεπεράσω το όριο SMS μου;',
                    answer: 'Αν ξεπεράσετε το όριο SMS της περιόδου σας, θα χρειαστεί να ανανεώσετε τη συνδρομή σας ή να περιμένετε την επόμενη περίοδο.'
                }
            }
        },
        usage: {
            title: 'Χρήση SMS',
            currentPeriod: 'Τρέχουσα περίοδος',
            used: 'Χρησιμοποιημένα',
            planned: 'Προγραμματισμένα',
            remaining: 'Απομένουν',
            of: 'από',
            sms: 'SMS',
            noUsage: 'Δεν υπάρχει χρήση αυτή τη περίοδο',
            exceeded: {
                title: 'Υπέρβαση ορίου',
                message: 'Δεν έχετε αρκετά διαθέσιμα SMS για να καλύψετε τα προγραμματισμένα. Αν δεν αναβαθμίσετε τη συνδρομή σας, κάποια SMS δεν θα αποσταλούν.'
            },
            tooltips: {
                used: 'SMS που έχουν ήδη αποσταλεί',
                planned: 'SMS προγραμματισμένα για την τρέχουσα περίοδο χρέωσης (δεν περιλαμβάνονται προγραμματισμένα SMS για μελλοντικούς μήνες)'
            },
            threshold: {
                error: {
                    message: 'Έχετε περισσότερα προγραμματισμένα & αποσταλμένα SMS για την περίοδο από όσα έχετε διαθέσιμα. Αυτό θα προκαλέσει αποτυχία αποστολής σε ορισμένες υπενθυμίσεις SMS. '
                },
                cta: 'Αναβάθμιση πλάνου τώρα'
            }
        },
        history: {
            title: 'Ιστορικό χρήσης',
            subtitle: 'Προηγούμενες περιόδους',
            period: 'Περίοδος',
            used: 'Χρησιμοποιημένα',
            empty: {
                title: 'Χωρίς ιστορικό',
                subtitle: 'Δεν υπάρχουν προηγούμενες περιόδους'
            }
        },
        scheduled: {
            title: 'SMS',
            subtitle: 'Προγραμματισμένα και αποστολές SMS',
            tabs: {
                scheduled: 'Προγραμματισμένα SMS',
                sent: 'Απεσταλμένα SMS',
                failed: 'Αποτυχίες αποστολής SMS'
            },
            comingSoon: 'Σύντομα θα είναι διαθέσιμο',
            empty: {
                future: {
                    title: 'Δεν βρέθηκαν μηνύματα',
                    subtitle: 'Δεν υπάρχουν προγραμματισμένα SMS στο μέλλον'
                },
                failed: {
                    title: 'Δεν βρέθηκαν μηνύματα',
                    subtitle: 'Δεν υπάρχουν αποτυχίες αποστολής SMS'
                },
                sent: {
                    title: 'Δεν βρέθηκαν μηνύματα',
                    subtitle: 'Δεν έχει σταλεί κανένα SMS'
                }
            },
            table: {
                message: 'Μήνυμα',
                segments: '{count} SMS',
                error: 'Σφάλμα',
                retries: 'Επανάληψη',
                status: {
                    sent: 'Απεστάλη',
                    failed: 'Αποτυχία',
                    scheduled: 'Προγραμματισμένο',
                    pending: 'Εκκρεμές'
                }
            }
        },
        settings: {
            title: 'Ρυθμίσεις SMS',
            subtitle: 'Διαχειριστείτε τις ρυθμίσεις των SMS υπενθυμίσεων',
            enable: {
                title: 'Ενεργοποίηση SMS Υπενθυμίσεων',
                description: 'Αποστολή αυτόματων SMS υπενθυμίσεων για κάθε ραντεβού που δημιουργείται'
            },
            reminder: {
                title: 'Ρυθμίσεις Υπενθύμισης',
                description: 'Ρυθμίστε πότε θα αποστέλλονται οι υπενθυμίσεις πριν από το ραντεβού',
                hoursBefore: 'Ώρες πριν από το ραντεβού'
            },
            senderName: {
                title: 'Όνομα Αποστολέα',
                description: 'Το όνομα που θα εμφανίζεται ως αποστολέας στα SMS',
                note: 'Χρησιμοποιήστε μόνο λατινικούς χαρακτήρες (greeklish), έως 11 χαρακτήρες.',
                validation: {
                    required: 'Το όνομα αποστολέα είναι υποχρεωτικό',
                    maxLength: 'Το όνομα αποστολέα δεν μπορεί να ξεπερνά τους {max} χαρακτήρες',
                    greeklish: 'Επιτρέπονται μόνο λατινικοί χαρακτήρες, αριθμοί και κενά'
                }
            },
            messageTemplate: {
                title: 'Κείμενο μηνύματος',
                description: 'Το κείμενο που λαμβάνουν οι πελάτες σου. Τα {date} και {time} γίνονται η ημερομηνία και η ώρα του ραντεβού.',
                insert: 'Πρόσθεσε:',
                placeholders: {
                    date: 'Ημερομηνία',
                    time: 'Ώρα'
                },
                reset: 'Επαναφορά προεπιλογής',
                counter: '{length}/{limit} χαρακτήρες · {segments} SMS ανά υπενθύμιση',
                multiPart: 'Το κείμενο ξεπερνά τους {chars} χαρακτήρες, οπότε κάθε υπενθύμιση χρεώνεται {segments} SMS από το πακέτο σου.',
                applyToScheduled: 'Ενημέρωσε και την προγραμματισμένη υπενθύμιση | Ενημέρωσε και τις {count} προγραμματισμένες υπενθυμίσεις',
                applyCost: 'Θα χρεωθούν {after} SMS συνολικά αντί για {before}.',
                keepScheduled: 'Όσες είναι ήδη προγραμματισμένες κρατούν το προηγούμενο κείμενο, εκτός αν αλλάξει το ραντεβού.',
                errors: {
                    EMPTY: 'Γράψε το κείμενο της υπενθύμισης.',
                    MISSING_PLACEHOLDER: 'Το κείμενο πρέπει να περιέχει την ημερομηνία και την ώρα του ραντεβού.',
                    HAS_LINK: 'Αφαίρεσε τον σύνδεσμο· οι υπενθυμίσεις δεν μπορούν να περιέχουν συνδέσμους.',
                    TOO_LONG: 'Συντόμευσε το κείμενο ώστε να χωράει σε {max} SMS ({chars} χαρακτήρες).'
                },
                confirm: {
                    title: 'Κάθε υπενθύμιση θα χρεώνεται {segments} SMS',
                    body: 'Το νέο κείμενο ξεπερνά τους {chars} χαρακτήρες ενός SMS, οπότε από εδώ και πέρα κάθε υπενθύμιση θα καταναλώνει {segments} SMS από το πακέτο σου.',
                    ok: 'Αποθήκευση'
                }
            },
            hours: 'ώρες'
        }
    }

}
